module.exports = __webpack_public_path__ + "img/FailureTurtle3.b8150cf4.gif";